import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { useResizeModal } from '../../Modal'
import { LabelForm } from '../LabelForm'

import { QA_NAME_LABEL_CREATION_MODAL } from './LabelFormModal.constants'

function LabelFormModal({
  title = 'Modal.NewLabelTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  return (
    <LabelForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_LABEL_CREATION_MODAL,
        setCloseConfirm,
        title: t(title),
        onClose,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      contentComponentProps={{ isFullScreen: isMobileScreenSize || fullScreen }}
      setModal={setModal}
      onCancel={handleClose}
      onCloseModal={handleCloseModal}
    />
  )
}

export default LabelFormModal
